import { useTranslation } from 'react-i18next';

import { TChannelTypeGroup } from '@/entities/channel';
import { Box } from '@/shared/ui';
import { Dialog, TDialogBase } from '@/shared/ui/Dialog';
import { Button } from '@/shared/ui/lib/Button';
import { SvgIcon } from '@/shared/ui/SvgIcon';

import { ChannelCard } from './ChannelCard/ChannelCard';

type TSelectChannelTypeDialogProps = TDialogBase & {
  onSelected: (channelType: TChannelTypeGroup) => void;
};

const wideLogoSx = { width: 88, height: 24 } as const;
const vkLogoSx = { width: 40, height: 40 } as const;

export const SelectChannelTypeDialog = ({
  onClose,
  onSelected,
  ...otherProps
}: TSelectChannelTypeDialogProps) => {
  const { t } = useTranslation();

  const createOnClickHandler = (channelType: TChannelTypeGroup) => () => {
    onSelected(channelType);
  };

  return (
    <Dialog
      onClose={onClose}
      title={t('channels:selectChannelTypeDialog.title')}
      leftButtonSlot={
        <Button variant="outlined" onClick={onClose}>
          {t('channels:buttons.cancel')}
        </Button>
      }
      {...otherProps}
    >
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr 1fr', sm: 'repeat(4, 150px)' },
          gap: '10px',
        }}
      >
        <ChannelCard
          icon={<SvgIcon name="telegram" fontSize="inherit" />}
          label="Telegram"
          onClick={createOnClickHandler('telegram')}
        />
        <ChannelCard
          icon={<SvgIcon name="whatsapp" fontSize="inherit" />}
          label="WhatsApp"
          onClick={createOnClickHandler('whatsapp')}
        />
        <ChannelCard
          icon={<SvgIcon name="max" fontSize="inherit" />}
          label="MAX"
          onClick={createOnClickHandler('max')}
        />
        <ChannelCard
          icon={<SvgIcon name="vk" viewBox="0 0 48 48" sx={vkLogoSx} />}
          label="VK"
          onClick={createOnClickHandler('vk')}
        />
        <ChannelCard
          icon={<SvgIcon name="avito" fontSize="inherit" />}
          label="Avito"
          onClick={createOnClickHandler('avito')}
        />
        <ChannelCard
          icon={
            <SvgIcon
              name="wildberries"
              viewBox="0 0 500 75.1"
              sx={wideLogoSx}
            />
          }
          label="Wildberries"
          onClick={createOnClickHandler('wildberries')}
        />
        <ChannelCard
          icon={<SvgIcon name="ozon" viewBox="0 0 485 106" sx={wideLogoSx} />}
          label="OZON"
          onClick={createOnClickHandler('ozon')}
        />
      </Box>
    </Dialog>
  );
};
